import { createContext } from 'react';

const NavigationContext = createContext(undefined);

export { NavigationContext };
